import cn from 'classnames';
import { memo, useContext } from 'react';
import { animated } from 'react-spring';
import { IJackpotPlayerObject, IPlayerProperties } from '@api/types/jackpot';
// import { ReactComponent as StarIcon } from "@assets/svg/star.svg";
import styles from './stats.module.scss';
import { playersColorContext } from '@views/jackpot';
import { ReactComponent as CrownIcon } from '@assets/svg/crown.svg';
import { ReactComponent as CoinIcon } from '@assets/svg/coin.svg';
import { calcChanceToWin } from '@utils/jackpot';
import CountUp from 'react-countup';
import Avatar from '@components/avatar';
import useReduxState from '@hooks/useReduxState';
import useJackpotRoom from '@hooks/useJackpotRoom';

export interface IPlayerProps extends IPlayerProperties {
    data: IJackpotPlayerObject;
    style: any;
    className?: string;
}

const Player = ({
    playerNumber,
    isWinner,
    // isLikelyToWin,
    data: { total_stake, user },
    style,
    className = '',
}: IPlayerProps): JSX.Element => {
    const [{ rooms }] = useReduxState((state) => state.jackpot);
    const { currentRoom } = useJackpotRoom();
    const game = rooms[currentRoom].current_game;

    const playersColors = useContext(playersColorContext);

    const handleColor = (): string => {
        const color = playersColors.players[playerNumber - 1].color;
        return color.slice(1, color.length);
    };

    /* ClassNames */

    const classNames = cn(styles.player, className, {
        [styles[`player-color-${handleColor()}`]]: handleColor(),
        [styles[`player-line-color-${handleColor()}`]]: handleColor(),
        [styles.winner]: isWinner,
    });

    const crownClasses = cn(styles.player__crownicon, {
        [styles.winner]: isWinner,
    });

    return (
        <animated.div className={classNames} style={style}>
            <div className={styles.shadow} />
            {/* {isLikelyToWin && <StarIcon className={styles.player__staricon} />} */}
            <CrownIcon className={crownClasses} />
            <Avatar
                borderColor={handleColor()}
                src={user.avatar_url}
                alt={user.username}
                width="64"
            />

            <p className={styles.username}>{user.username}</p>
            <p className={styles.player__odds}>
                <CountUp
                    end={calcChanceToWin({ bank: game.bank, total_stake })}
                    duration={1}
                />
                %
            </p>
            <p className={styles.player__amount}>
                <CoinIcon />
                <span>{total_stake / 100}</span>
            </p>
        </animated.div>
    );
};

export default memo(Player);
